export const Footer = () => <footer>
  <p>Created by <a href="https://clhenrick.io">Chris Henrick</a></p>
  <p><a href="https://github.com/clhenrick/metronome-app">Source Code</a></p>
</footer>
